export default "__VITE_ASSET__BjC$$5R8__"